// extracted by mini-css-extract-plugin
export var headerCell = "_51-1";
export var loadingSpinnerContainer = "_51-4";
export var loadingStateCell = "_51-5";
export var rowWrapper = "_51-3";
export var standaloneTable = "_51-6";
export var table = "_51-0";
export var white = "_51-2";